import { FT5_VIEW_TRACKING } from '../../../constants';
import { submitMerge } from '@otto-ec/tracking-bct';

export function registerViewTracking() {
    o_global.eventQBus.on(FT5_VIEW_TRACKING, (trackingData: Record<string, Array<string>>) => {
        submitMerge({ ot_PageCluster: ['Kundenbewertungsseite'], ...trackingData });
    });
}
